async function refreshAccessToken() {
    try {
      const response = await fetch('/refresh', {
        method: 'POST',
        credentials: 'include',
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || 'Refresh failed');
      }
  
      console.log('Access token refreshed!');
      return true;
  
    } catch (err) {
      console.error('Refresh token invalid or expired:', err);
      logout();  // ⬅️ Auto-logout if refresh fails
      return false;
    }
  }
  async function logout() {
    try {
      await fetch('/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      window.location.href = '/login'; // Always go back to login
    }
  }
  
  const AuthControl=async(response, navigate)=>
  {
    if(response.status===401)
    {
      window.alert("Yetkisiz işlem, girişe yönlendiriliyorsunuz.");
      navigate("/login",{replace:true});
    }
  }

  export{refreshAccessToken, logout, AuthControl};